// Generated by ReScript, PLEASE EDIT WITH CARE


let intervals = [
  "quarterHour",
  "hour",
  "day",
  "week",
  "month"
];

let metrics = [
  "freeMin",
  "freeMean",
  "occupiedMean",
  "occupiedMax",
  "occupancyPctMin",
  "occupancyPctMean",
  "occupancyPctMax"
];

export {
  intervals,
  metrics,
}
/* No side effect */
